import { Reveal, Overline } from "./Reveal";
import { STATS } from "../../data/content";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const Stats = () => {
  const navigate = useNavigate();
  return (
  <section id="impact" className="relative bg-[#103a2a] py-28 md:py-40">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <Overline>02 — Executive Highlights</Overline>
          <h2 className="mt-6 font-display text-4xl font-bold leading-[1.05] text-white sm:text-5xl lg:text-6xl">
            Measurable
            <br />
            commercial outcomes
          </h2>
        </div>
        <p className="max-w-sm text-[15px] leading-relaxed text-[#a1a1aa]">
          A record of building businesses, negotiating high-value deals and leading teams that
          deliver at scale across Australia and Asia.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-px overflow-hidden border border-white/10 bg-white/10 md:grid-cols-2 lg:grid-cols-12">
        {STATS.map((s, i) => (
          <Reveal
            key={i}
            delay={0.05 * i}
            className={`${s.span || "lg:col-span-4"} group bg-[#103a2a]`}
          >
            <div
              data-testid={`stat-${i}`}
              className="flex h-full flex-col justify-between p-8 transition-colors duration-500 group-hover:bg-[#184a34] md:p-10"
            >
              <span className="font-display text-4xl font-extrabold tracking-tight text-white md:text-5xl lg:text-6xl">
                {s.value}
              </span>
              <p className="mt-8 max-w-xs text-[13px] uppercase leading-relaxed tracking-[0.12em] text-[#a1a1aa]">
                {s.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-14 flex flex-col items-start justify-between gap-6 border border-[#c9a24e]/25 bg-[#0c2c20] p-8 md:flex-row md:items-center md:p-10">
          <div>
            <p className="font-serif-e text-2xl italic text-white md:text-3xl">
              See the work up close.
            </p>
            <p className="mt-2 text-[14px] text-[#a1a1aa]">
              Moments from boardrooms, renewable sites, farms, marinas and events.
            </p>
          </div>
          <button
            data-testid="impact-gallery-cta"
            onClick={() => navigate("/gallery")}
            className="group inline-flex shrink-0 items-center gap-4 bg-[#c9a24e] px-8 py-4 text-sm uppercase tracking-[0.2em] text-black transition-colors hover:bg-white"
          >
            View the gallery
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
